export default {
    init: (state, payload) => {
        state.doctype = payload.doctype
        state.docid = payload.docid
    },
}
